import {
  ChangeDetectorRef,
  Component,
  Input,
  Output,
  ChangeDetectionStrategy,
  SimpleChanges,
  OnChanges,
  EventEmitter,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  Report,
  ReportService,
  ReportSchedule,
} from '../../services/report.service';
import swal from 'sweetalert2';
import { ConfirmDialogueComponent } from '../confirm-dialogue/confirm-dialogue.component';
import { MatDialog } from '@angular/material/dialog';
import { enumScheduleTimePeriod } from '../../model/types/schedule-time-period.enum';
import { enumScheduleDailyFrequency } from '../../model/types/schedule-daily-frequency.enum';
import { enumScheduleDailyFrequencyTime } from '../../model/types/schedule-daily-frequency-time.enum';
import { enumScheduleStatus } from '../../model/types/schedule-status.enum';
import { MatSelectChange } from '@angular/material/select';
import moment from 'moment';
import * as m from 'moment';

@Component({
  selector: 'angular-monorepo-auth-suite-report-schedule-ui',
  templateUrl: './report-schedule.component.html',
  styleUrls: ['./report-schedule.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReportScheduleComponent implements OnChanges {
  _saveBtnstate = false;
  private _reportId: number;

  // Container component passes the client object for update to this Presentation component
  public _schedule: ReportSchedule;
  public _report: Report;
  private _saveResponse: string;
  public _showMsg: boolean;
  public _message: string;
  public mdenumScheduleTimePeriod = enumScheduleTimePeriod;
  public mdenumScheduleDailyFrequency = enumScheduleDailyFrequency;
  public mdenumScheduleDailyFrequencyTime = enumScheduleDailyFrequencyTime;
  public mdenumScheduleStatus = enumScheduleStatus;

  public moment = m;
  // For Container component to set save Button state

  @Input() set saveBtnstate(state: boolean) {
    console.log(`ui -- saveBtnstate: ${state}`);
    this._saveBtnstate = state;
  }

  @Input() set report(reportObj: Report | undefined) {
    console.log(`ui -- reportObj: ${reportObj}`);
    this._report = reportObj;
  }

  @Input() set schedule(scheduleObj: ReportSchedule | undefined) {
    console.log(`ui -- scheduleObj: ${scheduleObj}`);
    this._schedule = scheduleObj;
  }

  // Container component passes the CreateResponse to this Presentation component
  @Input() set saveResponse(response: string) {
    console.log(`ui -- createResponse: ${response}`);
    this._saveResponse = response;
  }

  // Container component passes the showmessageflag to this Presentation component
  @Input() set showMsg(show: boolean) {
    console.log(`ui -- showMsg: ${show}`);
    this._showMsg = show;
  }

  @Input() set message(msg: string) {
    console.log(`ui -- message: ${msg}`);
    this._message = msg;
  }

  // Presentation component emitting events to Container component to Save Report
  @Output() save: EventEmitter<ReportSchedule> = new EventEmitter();

  @Output() close: EventEmitter<boolean> = new EventEmitter();

  @Output() delete: EventEmitter<ReportSchedule> = new EventEmitter();

  @Output() formNotSaved: EventEmitter<boolean> = new EventEmitter();

  schedule_validation_messages = {
    reportName: [{ type: 'required', message: 'Report Name is required' }],
    status: [{ type: 'required', message: 'Status is required' }],
    dailyFrequency: [
      { type: 'required', message: 'Daily Frequency is required' },
    ],
    dailyFrequencyTime: [
      { type: 'required', message: 'Daily FrequencyTime is required' },
    ],
    timePeriod: [{ type: 'required', message: 'Time Period is required' }],
    reportFormatsAllowed: [
      { type: 'required', message: 'Report Formats Allowed is required' },
    ],
    defaultReportFormat: [
      { type: 'required', message: 'Default Report Format is required' },
    ],
    timePeriodDay: [
      { type: 'min', message: 'Min allowed value' },
      { type: 'max', message: 'Max allowed value' },
      { type: 'pattern', message: 'Out of Range see field hint' },
    ],
    timePeriodEvery: [
      { type: 'required', message: 'Time Period Every is required' },
      { type: 'min', message: 'Min allowed value' },
      { type: 'max', message: 'Max allowed value' },
    ],
    dailyIncrement: [
      { type: 'pattern', message: 'Out Of Range see field hint' },
    ],
    reportFormat: [{ type: 'required', message: 'Report Format is required' }],
  };

  timePeriod: Array<any> = [
    {
      val: 1,
      dVal: 'Daily',
      timePeriodEvery: { min: 1, max: 7 },
      timePeriodEveryHint: 'Run every x Days, where Days are 1-7',
      timePeriodDay: { min: null, max: null },
      timePeriodDayHint: 'Not Used',
    },
    {
      val: 2,
      dVal: 'Weekly',
      timePeriodEvery: { min: 1, max: 5 },
      timePeriodEveryHint: 'Run every x Weeks, where weeks are 1-5',
      timePeriodDay: {
        min: null,
        max: null,
        regex: '^(?!.*([1-7])\\1{1})(?=.*[1-7])(?=.*\\d)[1-7]+$',
      },
      timePeriodDayHint:
        'Run on days xxxx, where Sunday=Day 1,Saturday=Day 7 (where 23456 would be Monday thru Friday)',
    },
    {
      val: 3,
      dVal: 'Monthly',
      timePeriodEvery: { min: 1, max: 12 },
      timePeriodEveryHint: 'Run every x Months, where months are 1-12',
      timePeriodDay: {
        min: 1,
        max: 31,
        regex: '^([0-9]|1[0-9]|2[0-9]|3[01])$',
      },
      timePeriodDayHint:
        'Run on day x, where day=1-31, where 31=last day of month',
    },
  ];

  dailyFrequencyTime: Array<any> = [
    {
      val: 1,
      dVal: 'Minutes',
      dailyIncrement: { regex: '^([1-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9])$' },
      dailyIncrementHint: 'Minutes 1 - 59',
    },
    {
      val: 2,
      dVal: 'Hourly',
      dailyIncrement: { regex: '^([1-9]|1[0-9]|2[0123])$' },
      dailyIncrementHint: 'Hours  0-23',
    },
  ];
  // { hour: moment().format('hh'), minute: 0 , second: 0}
  // { hour: moment().add( 2, 'hours').format('hh'), minute: 0, second: 0 }
  // ^(?!.*([1-7])\1{1})(?=.*[1-7])(?=.*\d)[1-7]+$
  // '^(?=.*[1-7])(?!.*([1-7]).*\\1).{1,7}$'
  scheduleForm: FormGroup = this.fb.group({
    id: [{ value: '', disabled: true }],
    reportFormat: [{ value: '', disabled: false }, [Validators.required]],
    timePeriod: [{ value: '', disabled: false }],
    timePeriodEvery: [{ value: 1, disabled: false }],
    timePeriodDay: [{ value: '', disabled: false }],
    dailyFrequency: [{ value: 1, disabled: false }],
    dailyFrequencyTime: [{ value: '', disabled: true }],
    dailyIncrement: [{ value: '', disabled: true }],
    dailyStartTime: [
      { value: moment().minute(0).format('HH:mm'), disabled: false },
    ],
    dailyEndTime: [
      {
        value: moment().add(2, 'hours').minute(0).format('HH:mm'),
        disabled: false,
      },
    ],
    runAfterGUID: [{ value: '', disabled: false }],
    lastFinished: [{ value: '', disabled: false }],
    lastSchedule: [{ value: '', disabled: false }],
    lastStarted: [{ value: '', disabled: false }],
    lastResult: [{ value: '', disabled: false }],
    emailOnCompletion: [{ value: '', disabled: false }],
    emailOnError: [{ value: '', disabled: false }],
    status: [{ value: 1, disabled: false }],
    recordDate: [{ value: '', disabled: true }],
    recordTime: [{ value: '', disabled: true }],
  });
  timePeriodEveryHint = '';
  timePeriodDayHint = '';
  dailyIncrementHint = '';

  get scheduleF() {
    return this.scheduleForm.controls;
  }

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private reportService: ReportService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    // console.log(`MandateRegisterSuspend changes ${JSON.stringify(changes)}`)
    for (const prop of Object.keys(changes)) {
      console.log(`changed-prop: ${prop}`);
      console.log(changes[prop].currentValue);
    }
    if (changes['schedule']) {
      // See C002 - 2026-04-20 - HE
      // if (changes['schedule'].currentValue !== undefined) {
      //   this.createForm();
      //   this.patchScheduleForm();
      // }
      const sched = changes['schedule'].currentValue as
        | ReportSchedule
        | undefined
        | null;
      if (sched === undefined || sched === null) {
        this.resetForm();
        this.cdr.markForCheck();
      } else {
        this.createForm();
        this.patchScheduleForm();
        this.cdr.markForCheck();
      }
    }
    this.scheduleForm.statusChanges.subscribe((val) => {
      // console.log('val changes');
      if (!this.scheduleForm.pristine) {
        this.formNotSaved.emit(true);
      }
    });
  }

  submit() {
    const newSchedule: ReportSchedule = Object.assign(
      {},
      this.scheduleForm.getRawValue()
    );
    // newSchedule.dailyStartTime = moment(this.scheduleF.dailyStartTime.value).format('hh:mm:ss');
    // newSchedule.dailyEndTime = moment(this.scheduleF.dailyEndTime.value).format('hh:mm:ss');
    console.log('submit');
    this.save.emit(newSchedule);
    this.scheduleForm.markAsPristine({ onlySelf: true });
    this.scheduleForm.markAsUntouched({ onlySelf: true });
    this.formNotSaved.emit(false);
  }

  deleteSchedule() {
    const delSchedule: ReportSchedule = Object.assign(
      {},
      this.scheduleForm.getRawValue()
    );
    this.delete.emit(delSchedule);
  }

  public createForm() {
    this.showMsg = false;
    this._saveBtnstate = false;
    console.log(this.scheduleForm);
  }

  private patchScheduleForm() {
    console.log('patch');
    console.log(this._schedule);
    this.scheduleForm.patchValue({
      id: this._schedule.id,
      reportFormat: this._schedule.reportFormat,
      timePeriod: enumScheduleTimePeriod[this._schedule.timePeriod],
      timePeriodEvery: this._schedule.timePeriodEvery,
      timePeriodDay: this._schedule.timePeriodDay,
      dailyFrequency: enumScheduleDailyFrequency[this._schedule.dailyFrequency],
      dailyFrequencyTime:
        enumScheduleDailyFrequencyTime[this._schedule.dailyFrequencyTime],
      dailyIncrement: this._schedule.dailyIncrement,
      dailyStartTime: this._schedule.dailyStartTime,
      dailyEndTime: this._schedule.dailyEndTime,
      runAfterGUID: this._schedule.runAfterGUID,
      lastFinished: this._schedule.lastFinished,
      lastSchedule: this._schedule.lastSchedule,
      lastStarted: this._schedule.lastStarted,
      lastResult: this._schedule.lastResult,
      emailOnCompletion: this._schedule.emailOnCompletion,
      emailOnError: this._schedule.emailOnError,
      status: enumScheduleStatus[this._schedule.status],
      recordDate: this._schedule.recordDate,
      recordTime: this._schedule.recordTime,
    });

    console.log(moment(this._schedule.dailyStartTime, 'hh:mm:ss').toObject());

    this.changeTimePeriod(enumScheduleTimePeriod[this._schedule.timePeriod]);
    this.changeDailyFrequency(
      enumScheduleDailyFrequency[this._schedule.dailyFrequency]
    );
    this.changeDailyFrequencyTime(
      enumScheduleDailyFrequencyTime[this._schedule.dailyFrequencyTime]
    );

    this.scheduleForm.markAsPristine({ onlySelf: true });
    this.scheduleForm.markAsUntouched({ onlySelf: true });
  }

  getAllErrors(form: FormGroup | FormArray): { [key: string]: any } | null {
    let hasError = false;
    const result = Object.keys(form.controls).reduce((acc, key) => {
      const control = form.get(key);
      const errors =
        control instanceof FormGroup || control instanceof FormArray
          ? this.getAllErrors(control)
          : control.errors;
      if (errors) {
        acc[key] = errors;
        hasError = true;
      }
      return acc;
    }, {} as { [key: string]: any });
    return hasError ? result : null;
  }

  showSwal(type) {
    if (type === 'warning-message-and-confirmation') {
      swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          target: 'deleteDialogue',
          showCancelButton: true,
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger',
          },
          confirmButtonText: 'Yes, Delete this Schedule!',
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.deleteSchedule();
            this.closeForm();
            this._report = undefined;
          }
        });
    }
  }

  resetForm() {
    this._schedule = undefined;
    this.scheduleForm.reset();

    this.createForm();
  }

  closeForm() {
    if (!this.scheduleForm.pristine) {
      const dialogRef = this.dialog.open(ConfirmDialogueComponent, {
        data: {
          message:
            'Schedule Not Saved, Do you want to discard unsaved changes?',
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.close.emit(!result);
        this.formNotSaved.emit(!result);
      });
      return;
    }

    this.close.emit(false);
  }

  changeTimePeriod(val: number) {
    const selectedTimePeriod = this.timePeriod.filter(
      (period) => period.val === val
    )[0];

    // timePeriodEvery
    this.timePeriodEveryHint = selectedTimePeriod.timePeriodEveryHint;
    this.scheduleForm.get('timePeriodEvery').clearValidators();
    this.scheduleForm.get('timePeriodEvery').updateValueAndValidity();

    this.scheduleForm
      .get('timePeriodEvery')
      .setValidators([
        Validators.min(selectedTimePeriod.timePeriodEvery.min),
        Validators.max(selectedTimePeriod.timePeriodEvery.max),
      ]);
    this.scheduleForm.get('timePeriodEvery').updateValueAndValidity();

    let i = this.schedule_validation_messages.timePeriodEvery.findIndex(
      (a) => a.type === 'min'
    );
    this.schedule_validation_messages.timePeriodEvery[i].message =
      this.schedule_validation_messages.timePeriodEvery[i].message +
      selectedTimePeriod.timePeriodEvery.min;
    i = this.schedule_validation_messages.timePeriodEvery.findIndex(
      (a) => a.type === 'max'
    );
    this.schedule_validation_messages.timePeriodEvery[i].message =
      this.schedule_validation_messages.timePeriodEvery[i].message +
      ' ' +
      selectedTimePeriod.timePeriodEvery.max;

    // timePeriodDay
    this.timePeriodDayHint = selectedTimePeriod.timePeriodDayHint;
    this.scheduleForm.get('timePeriodDay').clearValidators();
    this.scheduleForm.get('timePeriodDay').updateValueAndValidity();

    if (selectedTimePeriod.timePeriodDay.min === null) {
      this.scheduleForm
        .get('timePeriodDay')
        .setValidators([
          Validators.pattern(selectedTimePeriod.timePeriodDay.regex),
        ]);
    } else {
      this.scheduleForm
        .get('timePeriodDay')
        .setValidators([
          Validators.min(selectedTimePeriod.timePeriodDay.min),
          Validators.max(selectedTimePeriod.timePeriodDay.max),
          Validators.pattern(selectedTimePeriod.timePeriodDay.regex),
        ]);
    }
    this.scheduleForm.get('timePeriodDay').updateValueAndValidity();

    i = this.schedule_validation_messages.timePeriodDay.findIndex(
      (a) => a.type === 'min'
    );
    this.schedule_validation_messages.timePeriodDay[i].message =
      this.schedule_validation_messages.timePeriodDay[i].message +
      selectedTimePeriod.timePeriodDay.min;
    i = this.schedule_validation_messages.timePeriodDay.findIndex(
      (a) => a.type === 'max'
    );
    this.schedule_validation_messages.timePeriodDay[i].message =
      this.schedule_validation_messages.timePeriodDay[i].message +
      ' ' +
      selectedTimePeriod.timePeriodDay.max;

    if (val === 1) {
      this.scheduleForm
        .get('timePeriodDay')
        .disable({ onlySelf: true, emitEvent: true });
      this.scheduleForm.get('timePeriodDay').clearValidators();
      this.scheduleForm.get('timePeriodDay').updateValueAndValidity();
      this.scheduleForm
        .get('dailyFrequency')
        .enable({ onlySelf: true, emitEvent: true });
      this.scheduleForm.get('dailyFrequency').clearValidators();
      this.scheduleForm.get('dailyFrequency').updateValueAndValidity();
    } else if (val === 3) {
      this.scheduleForm.get('dailyFrequency').patchValue(1);
      this.scheduleForm.get('dailyFrequency').clearValidators();
      this.scheduleForm.get('dailyFrequency').updateValueAndValidity();
      this.changeDailyFrequency(1);
      this.scheduleForm
        .get('dailyFrequency')
        .disable({ onlySelf: true, emitEvent: true });
    } else {
      this.scheduleForm
        .get('timePeriodDay')
        .enable({ onlySelf: true, emitEvent: true });
      this.scheduleForm.get('timePeriodDay').clearValidators();
      if (selectedTimePeriod.timePeriodDay.min === null) {
        this.scheduleForm
          .get('timePeriodDay')
          .setValidators([
            Validators.pattern(selectedTimePeriod.timePeriodDay.regex),
          ]);
      } else {
        this.scheduleForm
          .get('timePeriodDay')
          .setValidators([
            Validators.min(selectedTimePeriod.timePeriodDay.min),
            Validators.max(selectedTimePeriod.timePeriodDay.max),
            Validators.pattern(selectedTimePeriod.timePeriodDay.regex),
          ]);
      }
      this.scheduleForm.get('timePeriodDay').updateValueAndValidity();
      this.scheduleForm
        .get('dailyFrequency')
        .enable({ onlySelf: true, emitEvent: true });
      this.scheduleForm.get('dailyFrequency').clearValidators();
      this.scheduleForm.get('dailyFrequency').updateValueAndValidity();
    }
  }

  changeDailyFrequencyTime(val: number) {
    if (val) {
      const selectedDailyFrequencyTime = this.dailyFrequencyTime.filter(
        (freq) => freq.val === val
      )[0];

      this.dailyIncrementHint = selectedDailyFrequencyTime.dailyIncrementHint;
      this.scheduleForm.get('dailyIncrement').clearValidators();
      this.scheduleForm.get('dailyIncrement').updateValueAndValidity();

      this.scheduleForm
        .get('dailyIncrement')
        .setValidators([
          Validators.pattern(selectedDailyFrequencyTime.dailyIncrement.regex),
        ]);
      this.scheduleForm.get('dailyIncrement').updateValueAndValidity();
    } else {
      this.scheduleForm.get('dailyIncrement').clearValidators();
      this.scheduleForm.get('dailyIncrement').updateValueAndValidity();
    }
  }

  changeDailyFrequency(val: number) {
    console.log(`changeDailyFrequency: ${val}`);
    if (val === 2) {
      this.scheduleForm
        .get('dailyIncrement')
        .enable({ onlySelf: true, emitEvent: false });
      this.scheduleForm
        .get('dailyIncrement')
        .setValidators([Validators.required]);
      this.scheduleForm
        .get('dailyFrequencyTime')
        .enable({ onlySelf: true, emitEvent: false });
      this.scheduleForm
        .get('dailyFrequencyTime')
        .setValidators([Validators.required]);
    } else {
      this.scheduleForm.get('dailyFrequencyTime').patchValue('');
      this.scheduleForm.get('dailyIncrement').patchValue('');
      this.scheduleForm
        .get('dailyIncrement')
        .disable({ onlySelf: true, emitEvent: false });
      this.scheduleForm.get('dailyIncrement').clearValidators();
      this.scheduleForm
        .get('dailyFrequencyTime')
        .disable({ onlySelf: true, emitEvent: false });
      this.scheduleForm.get('dailyFrequencyTime').clearValidators();
    }
    this.scheduleForm.get('dailyIncrement').updateValueAndValidity();
    this.scheduleForm.get('dailyFrequencyTime').updateValueAndValidity();
  }
}

// ========================================
// CHANGE LOG
// ========================================
// C002: Injected ChangeDetectorRef and extended ngOnChanges for schedule so that when currentValue is null or undefined, resetForm() runs and markForCheck() is called; when a schedule exists, patch path now also calls markForCheck(). Previous behavior: ngOnChanges only patched when currentValue was not undefined, so clearing the schedule (Close Schedule) left _schedule and form values stale while ChangeDetectionStrategy.OnPush prevented the template from reflecting the closed state until some other event fired—users saw the editor as still open when returning to the Schedule tab or view. New behavior: Explicit reset on schedule clear keeps the UI consistent with the list view. Reason: User report: close button did not dismiss the schedule editor reliably when browsing back. Context: angular-monorepo-auth-suite-report-schedule-ui fed by schedule$ | async from container. Impact: Slightly more markForCheck calls on schedule load; no public API change. - 2026-04-20 - HE
